import React, { useContext } from "react";
import { GlobalContext } from '../../contexts/GlobalContext';
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import PageTitle from "../../components/PageTitle/PageTitle";
import './WorkWithUs.css'
import Divider from "../../components/Divider/Divider";
import getImage from "../../useFull/getImage";

const WorkWithUs = () => {
    const { state } = useContext(GlobalContext);
    const language = state.language || 'pt-br';
    const {
        breadcrumb,
        selectedPage,
        breadCrumbImage,
        pageTitle,
        pageSubtitle,
        info,
        sentData
    } = require(`../../assets/languages/${language}/workWithUs.json`);
    return (
        <>
            <Breadcrumb
                beforeRoutes={breadcrumb}
                classColor='white100'
                selectedPage={selectedPage}
                image={breadCrumbImage}
            />
            <div className='main-container mg-bot-100'>
                <section className="section-container">
                    <PageTitle title={pageTitle} subtitle={pageSubtitle} />
                    <span>{info}</span>

                    <div className="container-sent-cv mg-top-70">
                        <span dangerouslySetInnerHTML={{ __html: sentData.sentEmail }} className="mg-r-50"></span>
                        <div className="divider-sent-cv-portrait">
                            <Divider isPortrait={true} height='100px'/>
                        </div>
                        <div className="divider-sent-cv-landscape">
                            <Divider isPortrait={false} width='70px' />
                        </div>
                        <div className="sent-cv-line-linkedin">
                            <div className="bg-icon" style={{ backgroundImage: `url(${getImage('social', 'linkedin.png')})`, width: '32px', height: '32px' }} />
                            <span dangerouslySetInnerHTML={{ __html: sentData.sentLinkedin }}></span>
                        </div>
                    </div>
                </section>
            </div>
        </>
    )

}

export default WorkWithUs
